import { c as _c } from "react/compiler-runtime";
import { usePriceCalendar } from "@website/accommodation-ui/price-calendar-wrapper/hooks";
import { PriceBox } from "@website/accommodation-ui/price-calendar-wrapper/price-box/price-box";
import { PriceCalendarProperties } from "@website/accommodation-ui/price-calendar-wrapper/types";
import { FC } from "react";
export const PriceCalendarMobile: FC<PriceCalendarProperties> = properties => {
  const $ = _c(4);
  const {
    list
  } = usePriceCalendar(properties);
  let t0;
  if ($[0] !== list) {
    t0 = list?.map(_temp);
    $[0] = list;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="scrollbar-none flex w-full snap-x snap-mandatory flex-row gap-2 overflow-y-hidden">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(item, index) {
  return <PriceBox key={index} {...item} />;
}